import React from 'react';

const BUTTON_CLASS =
  'bg-tertiary py-2 px-6 text-base text-white font-bold rounded-md mt-4';

interface PartiallyPaidMessageProps {
  redirectUrl: string;
}

// No automatic redirect to the open Checkout Session — business decision.
// The customer opts in by clicking "Continue to payment".
const PartiallyPaidMessage: React.FC<PartiallyPaidMessageProps> = ({
  redirectUrl
}) => {
  return (
    <div className="m-auto text-lg text-center" data-testid="PartiallyPaid">
      <div>
        <p>
          <b className="text-xl">Your purchase is partially complete</b>
        </p>
        <p className="mt-4">
          Payment is still required for the remaining product(s) in your
          purchase.
        </p>
        <button
          className={BUTTON_CLASS}
          type="button"
          onClick={() => window.location.assign(redirectUrl)}
          data-testid="continuePaymentButton"
        >
          Continue to payment
        </button>
        <p className="mt-4">
          If you have any questions, contact us at{' '}
          <a href="tel:+18888784588" className="underline">
            1-888-878-4588
          </a>{' '}
          or{' '}
          <a href="mailto:support@foxquilt.com" className="underline">
            support@foxquilt.com
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default PartiallyPaidMessage;
